if (accessLevel >= AccessType.WRITE)
  button.btn.btn-sm.btn-default.g-widget-metadata-edit-button
    i.icon-pencil
span.g-widget-metadata-key #{key}
span.g-widget-metadata-value
  pre #{value}
